var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({attrs:{"rounded":"","x-small":"","text":"","height":"34","title":"Anwesenheit eintragen","disabled":_vm.disabled}},_vm.$listeners),[(_vm.studentAbsence)?_c('AbsenceChip',{attrs:{"student-absence":_vm.studentAbsence}}):_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-square-edit-outline ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }